import { backendApi } from "../dynamicBAseQuery";

export const clientsApi = backendApi.injectEndpoints({
    endpoints: (builder) => ({
        commissionOneTimeList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `commissionOneTimeList`,
                body: { ...args }
            })
        }),
        commissionRecurringList: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `commissionRecurringList`,
                body: { ...args }
            })
        }),
        getCommissionManagement: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `getCommissionManagement`,
                body: { ...args }
            })
        }),

        updateCommissionManagement: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `updateCommissionManagement`,
                body: { ...args }
            })
        }),

        makeCommissionTrackerDetails: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `makeCommissionTrackerDetails`,
                body: { ...args }
            })
        }),
        fetchPaymentHistory: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `fetchPaymentHistory`,
                body: { ...args }
            })
        }),
    })
})

export const {
    useCommissionOneTimeListMutation,
    useGetCommissionManagementMutation,
    useUpdateCommissionManagementMutation,
    useCommissionRecurringListMutation,
    useMakeCommissionTrackerDetailsMutation,
    useFetchPaymentHistoryMutation,
} = clientsApi